__turbopack_context__.v({
  "quoteNewsFeedWrapper": "QuoteNewsFeed-module-scss-module__S-PL2a__quoteNewsFeedWrapper",
});
